import React from "react";
import PropTypes from "prop-types";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-store-rail.css";

const StorePropType = PropTypes.shape({
    title: PropTypes.string,
    imgUrl: PropTypes.string,
    url: PropTypes.string,
});

export function HomepageStoreItem({ store }) {
    return (
        <div className={styles.homepageStoreItem}>
            <LazyLoadImage
                className={styles.homepageStoreImg}
                src={store.imgUrl}
                alt={store.title}
            />
            <a className={styles.homepageStoreLink} href={store.url}>
                {store.title}
            </a>
        </div>
    );
}

HomepageStoreItem.propTypes = {
    store: StorePropType,
};

export function HomepageStoreRail({ stores }) {
    return (
        <Rail
            className={styles.homepageStoreRail}
            analyticsLabel={"homepage_store_rail"}
            title={""}
        >
            {stores.map((store) => {
                return <HomepageStoreItem key={store.url} store={store} />;
            })}
        </Rail>
    );
}

HomepageStoreRail.propTypes = {
    stores: PropTypes.arrayOf(StorePropType).isRequired,
};

export default HomepageStoreRail;
